import React, { useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { toast } from "../lib/toast";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    try {
      await axiosInstance.post("/api/auth/password/reset/", { email });
      setSubmitted(true);
      toast.success("If the account exists, the reset email is on its way.");
    } catch (err) {
      setError("Something went wrong. Please try again.");
      toast.error("Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 shadow-md dark:shadow-gray-900/50 rounded px-10 py-8 max-w-md w-full">
        <h2 className="type-page-title mb-2 text-center text-blue-600 dark:text-blue-400">Reset Password</h2>

        {submitted ? (
          <div className="text-center">
            <p className="type-body mb-4">
              If an account exists for <strong>{email}</strong>, we've sent a password reset link.
            </p>
            <p className="type-muted mb-6">
              Check your inbox and spam folder. The link expires in 1 hour.
            </p>
            <Link
              to="/login"
              className="text-blue-600 hover:underline text-sm"
            >
              Back to login
            </Link>
          </div>
        ) : (
          <>
            <p className="type-muted text-center mb-6">
              Enter your email and we'll send you a link to reset your password.
            </p>

            {error && <p className="text-red-500 mb-4 text-sm text-center">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-gray-700 dark:text-gray-300">Email</label>
                <input
                  type="email"
                  className="w-full px-4 py-2 mt-1 border dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 disabled:opacity-40 transition"
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <p className="type-muted mt-4 text-center">
              <Link to="/login" className="text-blue-600 hover:underline">
                Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
